import { render, staticRenderFns } from "./BuildingsMap.vue?vue&type=template&id=1762e578"
import script from "./BuildingsMap.vue?vue&type=script&lang=js"
export * from "./BuildingsMap.vue?vue&type=script&lang=js"
import style0 from "./BuildingsMap.vue?vue&type=style&index=0&id=1762e578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports